import application from 'application/application';

const controller = 'DefaultAccountController';

application.controller(controller, [
	'$scope',
	'$http',
	'API',
	'helper',
	'authentication',
	'$rootScope',
	'ngNotify',
	($scope, $http, API, helper, authentication, $rootScope, ngNotify) => {
		$scope.userName = authentication.getUserData('nome');

		$scope.userEmail = {
			emailAtual: authentication.getUserData('email')
		};

		const idUser = authentication.getUserData('idUsuarioCliente');
		const idParceiro = authentication.getUserData('idParceiro');

		$scope.changePassword = () => {
			$scope.expandFields = !$scope.expandFields;
		};

		$scope.user = {};

		$scope.saving = false;

		// $scope.userEmail = {};

		$scope.userLoading = true;

		$scope.userClone = {};

		$scope.userPassword = {};

		$http({
			...helper.http(API.usersCustomers, 'GET'),
			params: {
				...helper.httpFields([
					'id',
					'idPessoa',
					'ativoUsuario',
					'pessoa.idTipoPessoa',
					'pessoa.id',
					'pessoa.nome',
					'pessoa.idSexo',
					'pessoa.dataNascimentoAbertura',
					'pessoa.fone1',
					'pessoa.fone2',
					'pessoa.cpfcnpj',
					'pessoa.email',
					'pessoa.fotoId',
					'pessoa.foto',
					'dadosOAB.id',
					'dadosOAB.ativo',
					'dadosOAB.numero',
					'dadosOAB.idUF',
					'dadosOAB.nomeUF',
					'dadosOAB.idTipoOAB'
				]),
				IDs: idUser,
				idParceiro
			}
		})
			.then(response => {
				if (response.data.itens)
					$scope.user = convertDataUser(response.data.itens[0]);

				// $scope.userEmail.emailAtual = $scope.user.email;
				// $scope.userEmail.idUsuarioCliente = $scope.user.id;

				$scope.userClone = $.extend(true, {}, $scope.user);
			})

			.finally(() => ($scope.userLoading = false));

		/**********************************************************************/

		$scope.genders = helper.responseStore();

		$scope.recordGenders = responseStore => {
			$http({
				...helper.http(API.genders, 'GET'),
				params: {
					...helper.httpFields(['id', 'nome']),
					registrosPorPagina: -1
				}
			})
				.then(response =>
					responseStore.setItems(convertDataGenders(response.data.itens))
				)

				.finally(() => responseStore.setReady(true));
		};

		$scope.recordGenders($scope.genders);

		/**********************************************************************/

		$scope.cities = helper.responseStore();

		$scope.recordCities = responseStore => {
			$http({
				...helper.http(API.cities, 'GET'),
				params: {
					...helper.httpFields(['id', 'nome', 'idUF']),
					ativo: true,
					registrosPorPagina: -1
				}
			})
				.then(response => {
					responseStore.setItems(response.data.itens);

					validateCityValue($scope.customer);
				})

				.finally(() => responseStore.setReady(true));
		};

		/**********************************************************************/

		$scope.handlerCities = idUF =>
			$scope.cities.getItems().filter(value => value.idUF == idUF);

		/**********************************************************************/

		$scope.federativeUnits = helper.responseStore();

		$scope.recordFederativeUnits = responseStore => {
			$http({
				...helper.http(API.federativeUnits, 'GET'),
				params: {
					...helper.httpFields(['id', 'sigla', 'nome']),
					ativo: true,
					registrosPorPagina: -1
				}
			})
				.then(response => {
					responseStore.setItems(response.data.itens);

					$scope.recordCities($scope.cities);
				})

				.finally(() => responseStore.setReady(true));
		};

		$scope.recordFederativeUnits($scope.federativeUnits);

		$scope.OABTypes = helper.responseStore();

		$scope.recordTypesOAB = responseStore => {
			$http({
				...helper.http(API.typesOAB, 'GET'),
				params: {
					...helper.httpFields(['id', 'nome']),
					paginaAtual: responseStore.getCurrentPage(),
					registrosPorPagina: responseStore.getItemsPerPage(),
					...responseStore.getFilters()
				}
			})
				.then(response => responseStore.setItems(response.data.itens))

				.finally(() => responseStore.setReady(true));
		};

		$scope.recordTypesOAB($scope.OABTypes);
		/**********************************************************************/

		$scope.updateUserInfo = userInfo => {
			$scope.saving = true;

			$http({
				...helper.http(API.usersCustomers, 'PUT'),
				data: {
					itens: [convertDataUserToAPI(userInfo)]
				},
				messageOverride: {
					success() {
						ngNotify.set('Dados do perfil editados!', {
							type: 'success',
							position: 'bottom'
						});
					}
				}
			}).then(
				response => {
					$scope.user = convertDataUser(response.data.itens[0]);

					$scope.userClone = $.extend(true, {}, $scope.user);

					$('#mUpdateUserInfo').modal('hide');

					$scope.saving = false;
				},
				() => ($scope.user = $scope.userClone)
			);
		};

		/**********************************************************************/

		function validateCityValue(customer) {
			if (customer) {
				const value = $scope.cities
					.getItems()
					.find(city => city.idUF === customer.idUF);

				$('select[name="cidade"]').val('input', value && `number:${value.id}`);

				return !value;
			}
		}

		/**********************************************************************/

		function convertDataGenders(genders) {
			let treatedGenders = [];

			genders.forEach(gender => {
				let treatedGender = {
					id: gender.id,
					genero: gender.nome
				};

				treatedGenders.push(treatedGender);
			});

			return treatedGenders;
		}

		/**********************************************************************/

		function convertDataUser(user) {
			let treatedUser = {
				id: '',
				idPessoa: '',
				nome: '',
				idGenero: '',
				dataNascimento: '',
				telefone: '',
				numeroOAB: '',
				idOAB: '',
				idUFOAB: '',
				ufOAB: '',
				idTipoOAB: '',
				email: '',
				foto: '',
				idTipoPessoa: '',
				cpfcnpj: ''
			};

			if (!user) return treatedUser;

			treatedUser.id = user.id;
			treatedUser.idPessoa = user.pessoa.id;

			if (user.pessoa) {
				treatedUser.nome = user.pessoa.nome;
				treatedUser.idGenero = user.pessoa.idSexo;
				treatedUser.dataNascimento = user.pessoa.dataNascimentoAbertura;
				treatedUser.telefone = user.pessoa.fone1 || user.pessoa.fone2;
				treatedUser.email = user.pessoa.email;
				treatedUser.foto = user.pessoa.foto;
				treatedUser.idTipoPessoa = user.pessoa.idTipoPessoa;
				treatedUser.cpfcnpj = user.pessoa.cpfcnpj;
			}

			let index = null;

			if (user.dadosOAB && user.dadosOAB.some(item => item.ativo)) {
				index = user.dadosOAB.findIndex(
					item => item.ativo && item.idTipoOAB && item.idTipoOAB === -1
				);

				if (index === -1) index = user.dadosOAB.findIndex(item => item.ativo);
			}

			if (index != null) {
				treatedUser.idOAB = user.dadosOAB[index].id;
				treatedUser.numeroOAB = user.dadosOAB[index].numero;
				treatedUser.idUFOAB = user.dadosOAB[index].idUF;
				treatedUser.ufOAB = user.dadosOAB[index].nomeUF;
				treatedUser.idTipoOAB = user.dadosOAB[index].idTipoOAB;
			}

			return treatedUser;
		}

		/**********************************************************************/

		function convertDataUserToAPI(treatedUser) {
			let user = {
				id: 0,
				pessoa: {
					id: 0,
					idSexo: 0,
					dataNascimentoAbertura: '',
					fone1: '',
					email: '',
					cpfcnpj: ''
				},
				dadosOAB: [
					{
						id: 0,
						numero: '',
						idUF: 0,
						UF: '',
						idTipoOAB: 0,
						ativo: true
					}
				]
			};

			if (!treatedUser) return user;

			user.id = treatedUser.id;
			user.pessoa.id = treatedUser.idPessoa;
			user.pessoa.nome = treatedUser.nome;
			user.pessoa.idSexo = treatedUser.idGenero;
			user.pessoa.dataNascimentoAbertura = treatedUser.dataNascimento;
			user.pessoa.fone1 = treatedUser.telefone;
			user.pessoa.email = treatedUser.email;
			user.pessoa.cpfcnpj = treatedUser.cpfcnpj;
			user.dadosOAB[0].id = treatedUser.idOAB;
			user.dadosOAB[0].numero = treatedUser.numeroOAB;
			user.dadosOAB[0].idUF = treatedUser.idUFOAB;
			user.dadosOAB[0].nomeUF = treatedUser.ufOAB;
			user.dadosOAB[0].idTipoOAB = treatedUser.idTipoOAB;

			return user;
		}

		$scope.updateUserPassword = data => {
			$http({
				...helper.http(API.usersCustomers, 'ChangePassword'),
				method: 'PUT',
				data: {
					itens: [data]
				}
			}).then(() => {
				Object.keys(data).forEach(key => delete data[key]);

				$('#modalUpdateUserPassword').modal('hide');
			});
		};

		/**********************************************************************/

		$scope.updateUserEmail = data => {
			$http({
				...helper.http(API.usersCustomers, 'ChangeEmail'),
				method: 'PUT',
				data: {
					itens: [data]
				}
			})
				.then(() => {
					Object.keys(data).forEach(key => delete data[key]);
					$('#modalUpdateUserEmail').modal('hide');
					setTimeout(() => {
						$rootScope.signOut();
					}, 500);
				})
				.catch(() => $('#modalUpdateUserEmail').modal('hide'));
		};

		const defautEmptyEmail = {
			email: ''
		};

		/** Novo emails. */
		$scope.emptyEmail = helper.cloneSimpleObject(defautEmptyEmail);

		/** Armazenamento de resposta. */
		$scope.emails = helper
			.responseStore()

			.setItemsPerPage(-1);

		/** Carregar emails. */
		const recordEmails = (responseStore, callback = () => {}) => {
			$http({
				...helper.http(API.notificationsEmails, 'GET'),
				params: {
					...helper.httpFields(['*']),
					paginaAtual: responseStore.getCurrentPage(),
					registrosPorPagina: responseStore.getItemsPerPage(),
					...responseStore.getFilters(),
					flAtivo: true
				}
			})
				.then(response => {
					responseStore.setItems(response.data.itens);

					callback();
				})

				.finally(() => responseStore.setReady(true));
		};

		recordEmails($scope.emails);

		const createNotificationEmailModalSelector = '#modalCreateNotificationEmail';
		const createNotificationEmailInputSelector = '#inputCreateEmail';

		$(createNotificationEmailModalSelector)
			.off('shown.bs.modal.focusCreateNotificationEmail')
			.on('shown.bs.modal.focusCreateNotificationEmail', () =>
				$(createNotificationEmailInputSelector).trigger('focus')
			);

		$scope.$on('$destroy', () =>
			$(createNotificationEmailModalSelector).off('shown.bs.modal.focusCreateNotificationEmail')
		);

		$scope.openModal = id => $(`#${id}`).modal('show');

		$scope.openDeleteModal = (emails, email) => {
			$scope.emailsModal = emails;

			$scope.emailModal = email;

			$scope.openModal('modalDeleteEmail');
		};

		$scope.closeModal = id => $(`#${id}`).modal('hide');

		/** Excluir emails. */
		$scope.confirmDeleteEmail = (responseStore, item) => {
			$scope.saving = true;

			let items = [item];

			responseStore.setItemsAsBusy(item);

			$http({
				...helper.http(API.notificationsEmails, 'disable'),
				method: 'PUT',
				data: {
					iDs: items.map(value => value.id)
				},
				messageOverride: {
					success(response, notify) {
						notify.success('Email excluído!');
					}
				}
			})
				.then(
					response => responseStore.removeItems(response.data.itens, 'id'),
					() => responseStore.rowbackItems(items)
				)

				.finally(() => {
					responseStore.setItemsAsNotBusy(items);

					recordEmails($scope.emails);

					$('.modal').modal('hide');

					$scope.saving = false;
				});
		};

		$scope.emailValidate = /(^[a-z0-9.!#$%&'+\/=?^_`{|​}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]+(\.[[a-zA-Z0-9]+)?)(\s?\;\s?[a-z0-9.!#$%&'+\/=?^_`{|​}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]+(\.[[a-zA-Z0-9]+)?)*?$/i;

		$scope.createEmails = (responseStore, items, reset) => {
			$scope.saving = true;

			if (!Array.isArray(items)) items = [items];

			$http({
				...helper.http(API.notificationsEmails, 'POST'),
				data: {
					itens: helper.cloneSimpleObject(items)
				},
				messageOverride: {
					success(response, notify) {
						notify.success('Email cadastrado com sucesso!');
					},
					error(response, notify) {
						notify.danger('Erro ao adicionar email!');
					}
				}
			})
				.then(
					response => {
						responseStore.pushItems(response.data.itens);
					},
					function(error) {
						return error;
					}
				)

				.finally(() => {
					$scope.emptyEmail = helper.cloneSimpleObject(defautEmptyEmail);

					typeof reset === 'function' && reset();

					recordEmails($scope.emails);

					$('.modal').modal('hide');

					$scope.saving = false;
				});
		};

		$scope.selectTab = 'editDataClient';
		$scope.changeTab = tab => {
			if ($scope.selectTab)
				$(`#${$scope.selectTab}`).removeClass('active show');

			$scope.selectTab = tab;

			$(`#${tab}`).addClass('active show');
		};

		$scope.equalsEmail = (main, isNew, repeat) => {
			let atual = main.replace(/\s/g, '');

			if (isNew) var novo = isNew.replace(/\s/g, '');

			if (repeat) var confirmation = repeat.replace(/\s/g, '');

			if (atual == novo) {
				let id = document.getElementById('novoEmail');

				id.classList.add('invalid');

				$scope.emailEqualsNew = true;
			} else if (atual != novo) {
				let id = document.getElementById('novoEmail');

				id.classList.remove('invalid');

				$scope.emailEqualsNew = false;
			}

			if (atual == confirmation) {
				let id2 = document.getElementById('confirmacaoNovoEmail');

				id2.classList.add('invalid');

				$scope.emailEqualsConfir = true;
			} else if (atual != confirmation) {
				let id2 = document.getElementById('confirmacaoNovoEmail');

				id2.classList.remove('invalid');

				$scope.emailEqualsConfir = false;
			}

			if (!!confirmation && novo != confirmation) {
				let id2 = document.getElementById('confirmacaoNovoEmail');

				id2.classList.add('invalid');

				$scope.emailEqualsConfir = true;
			} else if (!!confirmation && novo != confirmation) {
				let id2 = document.getElementById('confirmacaoNovoEmail');

				id2.classList.remove('invalid');

				$scope.emailEqualsConfir = false;
			}
		};

		/************************** SENHA ************************************/

		const inputType = () => {
			$scope.inputType1 = 'password';
			$scope.inputType2 = 'password';
			$scope.inputType3 = 'password';
		};

		inputType();

		$scope.showPassword = num => {
			$scope[`inputType${num}`] =
				$scope[`inputType${num}`] === 'password' ? 'text' : 'password';
		};

		const minCharacters = /(^(?=.*[A-Z])(?=.*[0-9])(?=.*[a-z]).{8,}$)/;
		const minMedia = /(^[0-9a-zA-Z~,!,@,#,$,%,^,&,*,-,_,+,=,?,>,<]{9,})/;
		const minForte = /(^[0-9a-zA-Z~,!,@,#,$,%,^,&,*,-,_,+,=,?,>,<]{12,})/;

		$scope.passwordStrength = (senha, confirmacao) => {
			if (senha === undefined) return false;

			if (senha.match(minCharacters.source)) {
				$scope.strength = 'fraca';

				if (senha.match(minForte.source)) {
					$scope.strength = 'forte';
				} else if (senha.match(minMedia.source)) {
					$scope.strength = 'média';
				}
			} else {
				$scope.strength = 'inválida';
			}

			if (confirmacao != undefined) $scope.comparePassword(senha, confirmacao);
		};

		$scope.checkField = senha => {
			if (senha === undefined) $scope.strength = null;
		};

		$scope.comparePassword = (confirmacao, senha) => {
			$scope.samePassword =
				$scope.strength === 'inválida' ? false : senha === confirmacao;

			if (confirmacao === undefined) $scope.samePassword = null;
		};

		$scope.statusCurrentPassword = () => ($scope.currentPassword = null);

		$scope.modalOpenPassword = id => {
			$(id)
				.modal('show')
				.on('hidden.bs.modal', () => {
					['strength', 'samePassword'].forEach(value => {
						$scope[value] = null;
					});

					['novaSenha', 'ConfirmacaoNovaSenha', 'senhaAtual'].forEach(value => {
						$scope.userPassword[value] = undefined;
					});

					['1', '2', '3'].forEach(value => {
						$scope[`inputType${value}`] = 'password';
					});

					$scope.$resetFormValidation('nUpdateUserPassword')();
				});
		};
	}
]);

export default controller;
